document.addEventListener('DOMContentLoaded', () => {
    // Pobieranie elementu header
    const header = document.querySelector('header');

    // Pobieranie elementu menu-mini__border--bottom
    const menuMiniBorderBottom = document.querySelector('.menu-mini__border--bottom');

    // Funkcja do zmiany wysokości submenu-mini i dodawania klas
    function adjustHeightOnHover(event) {
        const menuMiniLi = event.currentTarget;
        const submenuMini = menuMiniLi.querySelector('.submenu-mini');
        const submenuMiniUl = menuMiniLi.querySelector('.submenu-mini__ul');
        
        if (submenuMini && submenuMiniUl) {
            // Pobierz wysokość submenu-mini__ul i ustaw ją na submenu-mini
            const submenuHeight = submenuMiniUl.scrollHeight;
            submenuMini.setAttribute('style', `height: ${submenuHeight + 1}px;`);
        }
        
        // Dodanie klas cieni na header, submenu-mini oraz klasy na menu-mini__border--bottom
        if (menuMiniLi.classList.contains('menu-mini__li--submenu')) {
            header.classList.add('header--shadow');
            submenuMini.classList.add('submenu-mini--shadow');
            if (menuMiniBorderBottom) {
                menuMiniBorderBottom.classList.add('menu-mini__border--active');
            }
        }
    }
    
    // Funkcja do resetowania wysokości submenu-mini i usuwania klas
    function resetHeight(event) {
        const menuMiniLi = event.currentTarget;
        const submenuMini = menuMiniLi.querySelector('.submenu-mini');
        
        if (submenuMini) {
            submenuMini.removeAttribute('style'); // Resetowanie wysokości do wartości domyślnej
        }
        
        // Usunięcie klas cieni z header, submenu-mini oraz klasy z menu-mini__border--bottom
        if (menuMiniLi.classList.contains('menu-mini__li--submenu')) {
            header.classList.remove('header--shadow');
            submenuMini.classList.remove('submenu-mini--shadow');
            if (menuMiniBorderBottom) {
                menuMiniBorderBottom.classList.remove('menu-mini__border--active');
            }
        }
    }
    
    // Pobierz wszystkie elementy z klasą 'menu-mini__li'
    const menuMiniLis = document.querySelectorAll('.menu-mini__li');
    
    menuMiniLis.forEach(menuMiniLi => {
        menuMiniLi.addEventListener('mouseover', adjustHeightOnHover);
        menuMiniLi.addEventListener('mouseout', resetHeight);
    });
});